import { authStore } from '../../modules/auth/auth.store';
import { router } from '../../app/router';
import { renderThemeToggle, wireThemeToggle } from './ThemeToggle';
import { escapeHTML } from '../lib/format';

export function renderNavbar(container: HTMLElement): void {
  const user = authStore.user;
  const currentHash = window.location.hash.replace('#', '') || '/';

  container.innerHTML = `
    <header class="navbar">
      <div class="container nav-container">
        <a href="#/" class="brand">
          <div class="brand-icon"><i class="fa-solid fa-heart"></i></div>
          <span>Zuri</span>
        </a>

        <nav class="nav-links">
          <a href="#/" class="nav-link ${currentHash === '/' ? 'active' : ''}">Home</a>
          <a href="#/discover" class="nav-link ${currentHash === '/discover' ? 'active' : ''}">Browse</a>
          <a href="#/membership" class="nav-link ${currentHash === '/membership' ? 'active' : ''}">Membership</a>
          <a href="#/safety" class="nav-link ${currentHash === '/safety' ? 'active' : ''}">Safety</a>
        </nav>

        <div class="nav-actions">
          ${renderThemeToggle()}
          ${user
            ? `<button class="btn btn-outline" id="navAccountBtn"><i class="fa-solid fa-user"></i> ${escapeHTML(user.displayName || user.email?.split('@')[0] || 'Account')}</button>`
            : `<button class="btn btn-outline" id="navSignInBtn"><i class="fa-solid fa-right-to-bracket"></i> Sign In</button>
               <button class="btn btn-primary" id="navGetStartedBtn">Get Started</button>`
          }
        </div>

        <button class="btn btn-ghost mobile-menu-toggle" id="mobileMenuBtn" aria-label="Open navigation menu">
          <i class="fa-solid fa-bars"></i>
        </button>
      </div>
    </header>

    <!-- Mobile Drawer Overlay -->
    <div class="drawer-overlay" id="drawerOverlay"></div>
    <aside class="mobile-drawer" id="mobileDrawer">
      <div class="flex items-center justify-between">
        <div class="brand">
          <div class="brand-icon"><i class="fa-solid fa-heart"></i></div>
          <span>Zuri</span>
        </div>
        <button class="btn btn-ghost" id="drawerCloseBtn"><i class="fa-solid fa-xmark"></i></button>
      </div>
      <nav class="flex flex-col gap-4 mt-4">
        <a href="#/" class="nav-link ${currentHash === '/' ? 'active' : ''} js-drawer-link">Home</a>
        <a href="#/discover" class="nav-link ${currentHash === '/discover' ? 'active' : ''} js-drawer-link">Browse Profiles</a>
        <a href="#/membership" class="nav-link ${currentHash === '/membership' ? 'active' : ''} js-drawer-link">VIP Membership</a>
        <a href="#/safety" class="nav-link ${currentHash === '/safety' ? 'active' : ''} js-drawer-link">Safety Guidelines</a>
      </nav>
      <div class="mt-auto flex flex-col gap-3">
        ${user
          ? `<button class="btn btn-outline w-full" id="drawerAccountBtn"><i class="fa-solid fa-user"></i> ${escapeHTML(user.displayName || 'Account')}</button>`
          : `<button class="btn btn-primary w-full" id="drawerSignInBtn"><i class="fa-solid fa-right-to-bracket"></i> Sign In / Register</button>`
        }
      </div>
    </aside>
  `;

  // Wire Theme Toggle
  wireThemeToggle();

  // Navigation handlers
  document.getElementById('navAccountBtn')?.addEventListener('click', () => router.navigate('/settings'));
  document.getElementById('navSignInBtn')?.addEventListener('click', () => router.navigate('/auth'));
  document.getElementById('navGetStartedBtn')?.addEventListener('click', () => router.navigate('/auth'));

  // Mobile Drawer Toggle logic
  const overlay = document.getElementById('drawerOverlay');
  const drawer = document.getElementById('mobileDrawer');
  const menuBtn = document.getElementById('mobileMenuBtn');
  const closeBtn = document.getElementById('drawerCloseBtn');

  function openDrawer(): void {
    overlay?.classList.add('open');
    drawer?.classList.add('open');
  }

  function closeDrawer(): void {
    overlay?.classList.remove('open');
    drawer?.classList.remove('open');
  }

  menuBtn?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  container.querySelectorAll('.js-drawer-link').forEach(link => {
    link.addEventListener('click', closeDrawer);
  });

  document.getElementById('drawerAccountBtn')?.addEventListener('click', () => {
    closeDrawer();
    router.navigate('/settings');
  });

  document.getElementById('drawerSignInBtn')?.addEventListener('click', () => {
    closeDrawer();
    router.navigate('/auth');
  });
}
